import { createAsyncThunk } from "@reduxjs/toolkit";
import audioCutAPI from "services/api/audio-cut";

export const checkAbruptCut = createAsyncThunk(`audio-cut-check/checkAbruptCut`, async (payload) => {
  try {
    const response = await audioCutAPI.checkAbruptCut(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const bulkCheckAbruptCut = createAsyncThunk(`audio-cut-check/bulkCheckAbruptCut`, async (payload) => {
  try {
    const response = await audioCutAPI.bulkCheckAbruptCut(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const saveCut = createAsyncThunk(`audio-cut-check/saveCut`, async (payload) => {
  try {
    const response = await audioCutAPI.saveCut(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
